export default __webpack_public_path__ + "static/media/logo.c7abb2b1.svg";